// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dmo1","left":"styles_left__3dzuV"};